import { render, staticRenderFns } from "./SectionsProgram.vue?vue&type=template&id=280ab282&scoped=true&"
import script from "./SectionsProgram.vue?vue&type=script&lang=js&"
export * from "./SectionsProgram.vue?vue&type=script&lang=js&"
import style0 from "./SectionsProgram.vue?vue&type=style&index=0&id=280ab282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ab282",
  null
  
)

export default component.exports